<div *ngIf="visible" class="loader-container">
  <div class="loader">
    <div class="dot red"></div>
    <div class="dot green"></div>
    <div class="dot blue"></div>
  </div>
</div>
